const a = {
  warning: "d-recipe-callbox-badge--warning"
}, c = {
  default: "d-recipe-callbox__border-default",
  ai: "d-recipe-callbox__border-ai",
  critical: "d-recipe-callbox__border-critical"
}, e = {
  CALLBOX_BADGE_COLORS: a,
  CALLBOX_BORDER_COLORS: c
};
export {
  a as CALLBOX_BADGE_COLORS,
  c as CALLBOX_BORDER_COLORS,
  e as default
};
//# sourceMappingURL=callbox-constants.js.map
